import scheduleApi from '@/store/api/schedule'
import {
  ADD_MILESTONE,
  ADD_MILESTONES,
  REMOVE_MILESTONE,
  SET_CURRENT_SCHEDULE_ITEMS,
  SET_SCHEDULE_SORT_MODE,
  LOAD_SORTED_SCHEDULE_START,
  LOAD_SORTED_SCHEDULE_END,
  LOAD_SORTED_SCHEDULE_ERROR,
  UPDATE_SORTED_SCHEDULE_ITEM,
  RESET_ALL
} from '@/store/mutation-types'
import moment from 'moment-timezone'

const initialState = {
  milestones: {},
  currentSortedSchedule: [],
  currentScheduleItems: [],
  isSortedScheduleLoading: false,
  isSortedScheduleLoadingError: false,
  scheduleSortMode: 0,
}

const LOG_PREFIX = 'src/modules/schedule.js:'
const handleError = (
  error,
  errorPrefix = '',
  errorMessage = '',
  additionalData = null
) => {
  console.error(`Error in ${errorPrefix}: ${errorMessage}`, error)
  if (additionalData) {
    console.error('Additional data:', additionalData)
  }
  // Implement additional error handling logic here
}

const state = { ...initialState }

const addDates = (elem, hierarchy) => {
  const p = elem.position
  if (elem.start_date && elem.start_date !== "None") {
    elem.startDate = moment(elem.start_date)
  }
  if (elem.end_date && elem.end_date !== "None") {
    elem.endDate = moment(elem.end_date)
  }
  if (state.scheduleSortMode === 1 && !elem.lowest && (elem.entity_type === "Shot" || elem.entity_type === "Sequence")) {
    const rot = hierarchy[p[0]]
    const seq = rot.children[p[1]]
    let dep = null
    if (p.length >= 3) {
      dep = seq.children[p[2]]
    }
    if (elem.startDate) {
      if (p.length >= 3 && (!dep.startDate) || dep.startDate > elem.startDate) {
        dep.startDate = elem.startDate.clone()
      }
      if ((!seq.startDate) || seq.startDate > elem.startDate) {
        seq.startDate = elem.startDate.clone()
      }
      if ((!rot.startDate) || rot.startDate > elem.startDate) {
        rot.startDate = elem.startDate.clone()
      }
    }
    if (elem.endDate) {
      if (p.length >= 3 && (!dep.endDate) || dep.endDate < elem.endDate) {
        dep.endDate = elem.endDate.clone()
      }
      if ((!seq.endDate) || seq.endDate < elem.endDate) {
        seq.endDate = elem.endDate.clone()
      }
      if ((!rot.endDate) || rot.endDate < elem.endDate) {
        rot.endDate = elem.endDate.clone()
      }
    }
  }
  if (p.length === 3) {
    const rot = hierarchy[p[0]]
    const dep = rot.children[p[1]]
    if (elem.startDate) {
      if ((!dep.startDate) || dep.startDate > elem.startDate) {
        dep.startDate = elem.startDate.clone()
      }
      if ((!rot.startDate) || rot.startDate > elem.startDate) {
        rot.startDate = elem.startDate.clone()
      }
    }
    if (elem.endDate) {
      if ((!dep.endDate) || dep.endDate < elem.endDate) {
        dep.endDate = elem.endDate.clone()
      }
      if ((!rot.endDate) || rot.endDate < elem.endDate) {
        rot.endDate = elem.endDate.clone()
      }
    }
  // } else if (state.scheduleSortMode === 1 && !elem.lowest && (elem.entity_type === "Shot" || elem.entity_type === "Sequence")) {
  //   const seq = hierarchy[p[0]].children[p[1]]
  //   const dep = hierarchy[p[0]].children[p[1]].children[p[2]]
  //   if (elem.startDate && (seq.startDate > elem.startDate || !seq.startDate)) {
  //     seq.startDate = elem.startDate.clone()
  //   }
  //   if (elem.endDate && (seq.endDate < elem.endDate || !seq.endDate)) {
  //     seq.endDate = elem.endDate.clone()
  //   }
  //   if (elem.startDate && (dep.startDate > elem.startDate || !dep.startDate)) {
  //     dep.startDate = elem.startDate.clone()
  //   }
  //   if (elem.endDate && (dep.endDate < elem.endDate || !dep.endDate)) {
  //     dep.endDate = elem.endDate.clone()
  //   }
  } else if (elem.lowest && elem.entity_type === "Shot") {
    const seq = hierarchy[p[0]].children[p[1]].children[p[2]].children[p[3]]
    if (elem.startDate && (seq.startDate > elem.startDate || !seq.startDate)) {
      seq.startDate = elem.startDate.clone()
    }
    if (elem.endDate && (seq.endDate < elem.endDate || !seq.endDate)) {
      seq.endDate = elem.endDate.clone()
    }
  }
  if (elem.children) {
    for (const child of elem.children) {
      addDates(child, hierarchy)
    }
  }
}

const getters = {
  milestones: state => state.milestones,
  isSortedScheduleLoading: state => state.isSortedScheduleLoading,
  isSortedScheduleLoadingError: state => state.isSortedScheduleLoadingError,
  currentScheduleItems: state => state.currentScheduleItems,
  currentSortedSchedule: state => state.currentSortedSchedule,
  scheduleSortMode: state => state.scheduleSortMode,
}

const actions = {
  setScheduleSortMode({commit}, val) {
    commit(SET_SCHEDULE_SORT_MODE, val)
  },

  loadScheduleMain({ commit }) {
    commit(LOAD_SORTED_SCHEDULE_START)
    return scheduleApi.getMainSchedule()
      .then(ret => {
        for (const e0 of ret) {
          addDates(e0, ret)
        }
        return ret
      })
      .then(ret => {
        commit(LOAD_SORTED_SCHEDULE_END, ret)
        return Promise.resolve(ret)
      })
      .catch(error => {
        commit(LOAD_SORTED_SCHEDULE_ERROR)
        handleError(
          error,
          `${LOG_PREFIX}/loadScheduleMain()`,
          'Failed to load schedule "main"' // TODO: PLEASE REVIEW DETAILS
        )
      })
  },

  loadScheduleFull({ commit, state }, production_id) {
    commit(LOAD_SORTED_SCHEDULE_START)
    return scheduleApi.getScheduleFull(production_id, state.scheduleSortMode === 1)
      .then(ret => {
        for (const e0 of ret) {
          addDates(e0, ret)
        }
        return ret
      })
      .then(ret => {
        commit(LOAD_SORTED_SCHEDULE_END, ret)
        return Promise.resolve(ret)
      })
      .catch(error => {
        commit(LOAD_SORTED_SCHEDULE_ERROR)
        handleError(
          error,
          `${LOG_PREFIX}/loadScheduleFull()`,
          'Failed to load schedule "full"' // TODO: PLEASE REVIEW DETAILS
        )
      })
  },

  loadEpisodeScheduleFull({ commit }, {production_id, episode_id}) {
    commit(LOAD_SORTED_SCHEDULE_START)
    return scheduleApi.getScheduleEpisodeFull(production_id, episode_id, state.scheduleSortMode === 1)
      .then(ret => {
        for (const e0 of ret) {
          addDates(e0, ret)
        }
        return ret
      })
      .then(ret => {
        commit(LOAD_SORTED_SCHEDULE_END, ret)
        return Promise.resolve(ret)
      })
      .catch(error => {
        commit(LOAD_SORTED_SCHEDULE_ERROR)
        handleError(
          error,
          `${LOG_PREFIX}/loadEpisodeScheduleFull()`,
          'Failed to load schedule "episode-full"' // TODO: PLEASE REVIEW DETAILS
        )
      })
  },

  updateSortedScheduleItem ({ commit }, item) {
    commit(UPDATE_SORTED_SCHEDULE_ITEM, item)
  },

  loadScheduleItems({ commit }, production) {
    return scheduleApi
      .getScheduleItems(production)
      .then(scheduleItems => {
        commit(SET_CURRENT_SCHEDULE_ITEMS, scheduleItems)
        return Promise.resolve(scheduleItems)
      })
      .catch(error => {
        handleError(
          error,
          `${LOG_PREFIX}/loadScheduleItems()`,
          'Failed to load schedule items' // TODO: PLEASE REVIEW DETAILS
        )
      })
  },

  loadAllScheduleItems({ commit }, production) {
    return scheduleApi
      .getAllScheduleItems(production)
      .then(scheduleItems => {
        commit(SET_CURRENT_SCHEDULE_ITEMS, scheduleItems)
      })
      .catch(error => {
        handleError(
          error,
          `${LOG_PREFIX}/loadAllScheduleItems()`,
          'Failed to load all schedule items' // TODO: PLEASE REVIEW DETAILS
        )
      })
  },

  loadAssetTypeScheduleItems({ commit }, { production, taskType }) {
    return scheduleApi
      .getAssetTypeScheduleItems(production, taskType)
      .catch(error => {
        handleError(
          error,
          `${LOG_PREFIX}/loadAssetTypeScheduleItems()`,
          'Failed to load asset type schedule items' // TODO: PLEASE REVIEW DETAILS
        )
      })
  },

  loadSequenceScheduleItems({ commit }, { production, taskType }) {
    return scheduleApi
      .getSequenceScheduleItems(production, taskType)
      .catch(error => {
        handleError(
          error,
          `${LOG_PREFIX}/loadSequenceScheduleItems()`,
          'Failed to load sequence schedule items' // TODO: PLEASE REVIEW DETAILS
        )
      })
  },

  loadEpisodeScheduleItems({ commit }, { production, taskType }) {
    if (!taskType.id) {
      return Promise.reject(new Error('Wrong task type for loading schedule'))
    } else {
      return scheduleApi
        .getEpisodeScheduleItems(production, taskType)
        .catch(error => {
        handleError(
          error,
          `${LOG_PREFIX}/loadEpisodeScheduleItems()`,
          'Failed to load episode schedule items' // TODO: PLEASE REVIEW DETAILS
        )
      })
    }
  },

  createScheduleItem({ commit, state }, scheduleItem) {
    if (!scheduleItem.object_id) {
      const previousItem = state.currentScheduleItems.find(
        item =>
          item.task_type_id === scheduleItem.task_type_id &&
          item.project_id === scheduleItem.project_id
      )
      if (previousItem) return Promise.resolve(scheduleItem)
    }
    return scheduleApi
      .createScheduleItem(scheduleItem)
      .then(newScheduleItem => {
        const scheduleItems = state.currentScheduleItems.slice()
        scheduleItems.push(newScheduleItem)
        commit(SET_CURRENT_SCHEDULE_ITEMS, scheduleItems)
        return Promise.resolve(newScheduleItem)
      })
      .catch(error => {
        handleError(
          error,
          `${LOG_PREFIX}/createScheduleItem()`,
          'Failed to create schedule item' // TODO: PLEASE REVIEW DETAILS
        )
      })
  },

  deleteScheduleItem({ commit, state }, scheduleItem) {
    return scheduleApi
      .deleteScheduleItem(scheduleItem)
      .then(() => {
        const scheduleItems = state.currentScheduleItems.slice()
        const indexToRemove = scheduleItems.findIndex(
          item => item.id === scheduleItem.id
        )
        if (indexToRemove !== -1) {
          scheduleItems.splice(indexToRemove, 1)
          commit(SET_CURRENT_SCHEDULE_ITEMS, scheduleItems)
        }
      })
      .catch(error => {
        handleError(
          error,
          `${LOG_PREFIX}/deleteScheduleItem()`,
          'Failed to delete schedule item' // TODO: PLEASE REVIEW DETAILS
        )
      })
  },

  saveScheduleItem({ commit, state }, scheduleItem) {
    return scheduleApi
      .updateScheduleItem(scheduleItem)
      .then(updatedItem => {
        const scheduleItems = state.currentScheduleItems.slice()
        const indexUpdate = scheduleItems.findIndex(
          item => item.id === updatedItem.id
        )
        if (indexUpdate !== -1) {
          scheduleItems[indexUpdate] = updatedItem
          commit(SET_CURRENT_SCHEDULE_ITEMS, scheduleItems)
        }
      })
      .catch(error => {
        handleError(
          error,
          `${LOG_PREFIX}/saveScheduleItem()`,
          'Failed to save schedule item' // TODO: PLEASE REVIEW DETAILS
        )
      })
  },

  loadMilestones({ commit, rootState }) {
    const production = rootState.productions.currentProduction
    return scheduleApi
      .getMilestones(production)
      .then(milestones => {
        commit(ADD_MILESTONES, milestones)
      })
      .catch(error => {
        handleError(
          error,
          `${LOG_PREFIX}/loadMilestones()`,
          'Failed to load milestones' // TODO: PLEASE REVIEW DETAILS
        )
      })
  },

  saveMilestone({ commit, rootState }, milestone) {
    const production = rootState.productions.currentProduction
    if (!milestone.id) {
      return scheduleApi
        .createMilestone(production, milestone)
        .then(milestone => {
          commit(ADD_MILESTONE, milestone)
        })
    } else {
      return scheduleApi
        .updateMilestone(milestone)
        .then(milestone => {
          commit(ADD_MILESTONE, milestone)
        })
        .catch(error => {
          handleError(
            error,
            `${LOG_PREFIX}/saveMilestone()`,
            'Failed to save milestone' // TODO: PLEASE REVIEW DETAILS
          )
        })
    }
  },

  deleteMilestone({ commit, rootState }, milestone) {
    return scheduleApi
      .deleteMilestone(milestone)
      .then(milestone => {
        commit(REMOVE_MILESTONE, milestone)
      })
      .catch(error => {
        handleError(
          error,
          `${LOG_PREFIX}/deleteMilestone()`,
          'Failed to delete milestone' // TODO: PLEASE REVIEW DETAILS
        )
      })
  }
}

const mutations = {
  [ADD_MILESTONE](state, milestone) {
    state.milestones[milestone.date] = milestone
  },

  [ADD_MILESTONES](state, milestones) {
    state.milestones = {}
    milestones.forEach(milestone => {
      state.milestones[milestone.date] = milestone
    })
  },

  [REMOVE_MILESTONE](state, milestone) {
    delete state.milestones[milestone.date.format('YYYY-MM-DD')]
  },

  [SET_CURRENT_SCHEDULE_ITEMS](state, items) {
    state.currentScheduleItems = items
  },

  [LOAD_SORTED_SCHEDULE_START](state) {
    state.currentSortedSchedule = []
    state.isSortedScheduleLoading = true
    state.isSortedScheduleLoadingError = false
  },

  [LOAD_SORTED_SCHEDULE_END](state, items) {
    state.currentSortedSchedule = items
    state.isSortedScheduleLoading = false
    state.isSortedScheduleLoadingError = false
  },

  [LOAD_SORTED_SCHEDULE_ERROR](state) {
    state.currentSortedSchedule = []
    state.isSortedScheduleLoading = false
    state.isSortedScheduleLoadingError = true
  },

  [UPDATE_SORTED_SCHEDULE_ITEM](state, item) {
    var element = { children: state.currentSortedSchedule }
    for (const ind of item.position) {
      if (!(element.children?.length > ind)) { return }
      element = element.children[ind]
    }
    Object.assign(element, item)
  },

  [RESET_ALL](state) {
    Object.assign(state, { ...initialState })
  },

  [SET_SCHEDULE_SORT_MODE](state, val) {
    state.scheduleSortMode = val
  } 
}

export default {
  state,
  getters,
  actions,
  mutations
}
